import React from "react"
import styles from "./styles.scss"

class Tags extends React.Component {
  render() {
    const { tags } = this.props

    return (
      <div className={styles.tagsContainer}>
        {tags.map(tag => (
          <div key={tag} className={styles.tag}>
            {tag}
          </div>
        ))}
      </div>
    )
  }
}

export default Tags



// WEBPACK FOOTER //
// ./src/components/CaseStudy/Hero/Tags/index.jsx